/* GAH-PZ round 3, version B (RUSTAM-TEST-01): "This order is a gift".

   Daniel, the owner (Oct 2): know who buys for themselves and who buys a
   gift, asked on the page and in the cart. The answer is one cart attribute,
   "Gift": "Yes", or removed. It is written:
   - when the cart's switch moves (snippets/benchmark-gift-toggle, in the
     drawer and on /cart), and
   - when version B's own switch on the page moves ("Are you buying this as
     a gift?", the shared gift / improve radios), so the cart opens already
     agreeing with what the visitor said there.
   The cart's row only shows to visitors in GAH-PZ-01 arm B (and for the rest
   of that tab), or when the cart already says gift. The arm can land after
   this file has run (Intelligems' per-arm JS), so it listens for gd:pz-arm
   (layout/theme.liquid apply) and gd:pz-ready (pzActivate, the page's radios
   wired) as well as reading the arm at start. The row's stylesheet is linked
   the first time a row shows, so nobody else downloads it.

   Best effort, like the other attribute writes in the theme: a failed write
   puts the switch back and never blocks the sale, and a Check out tap made
   while a write is in flight waits for it (InstantCart.hold). */
(() => {
  'use strict';

  if (window.GDGiftToggle) return;

  const KEY = 'Gift';
  const SEEN = 'gd_gift_ui';
  // arm B on any page: the PDP's class, or the arm GD_FLAGS holds elsewhere
  const isB = () => {
    const flags = window.GD_FLAGS;
    return document.documentElement.classList.contains('gd-pz-b') || !!(flags && flags.pzArmLive && flags.pzArmLive() === 'b');
  };
  // B's page switch exists only where pzActivate built arm B (the PDP)
  const onBPage = () => !!(window.GD_FLAGS && window.GD_FLAGS.pzActive === 'b');

  let seen = false;
  const markSeen = () => {
    seen = true;
    try { sessionStorage.setItem(SEEN, '1'); } catch (e) {}
  };
  try { seen = sessionStorage.getItem(SEEN) === '1'; } catch (e) {}
  if (isB()) markSeen();

  const boxes = () => [...document.querySelectorAll('[data-gd-gift-toggle]')];
  const paint = (on) => boxes().forEach((box) => { box.checked = on; });
  const linkStyles = (row) => {
    const href = row.getAttribute('data-gd-gift-css');
    if (!href || document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  };
  const reveal = () => {
    boxes().forEach((box) => {
      const row = box.closest('[data-gd-gift-row]');
      if (!row || !(seen || box.checked)) return;
      linkStyles(row);
      row.hidden = false;
    });
  };

  const updateUrl = () => {
    const base = window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update';
    return `${base}.js`;
  };

  // writes run one after another, so two quick taps land in the order made
  let queue = Promise.resolve();
  const write = (on) => {
    const attributes = { [KEY]: on ? 'Yes' : '' };
    /* GAH-GIFTPASS-01: a gift answer given here may come after the Add to
       Cart (whose stamp only sees an answer already given), so the arm rides
       this same write - the order then names its arm either way */
    const flags = window.GD_FLAGS;
    if (on && flags && typeof flags.giftPassInTest === 'function' && flags.giftPassInTest()) {
      attributes.gd_giftpass_arm = flags.giftPassArmName();
    }
    const run = () => fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
    }).then((res) => {
      if (!res.ok) throw new Error(`cart update ${res.status}`);
      return res.json();
    }).then((cart) => {
      if (window.CartOptimist && typeof window.CartOptimist.reconcile === 'function') window.CartOptimist.reconcile(cart);
      return cart;
    });
    const job = queue.then(run, run);
    queue = job.catch(() => {});
    if (window.InstantCart && typeof window.InstantCart.hold === 'function') window.InstantCart.hold(queue, { followUp: true });
    return job;
  };

  /* GAH-GIFTPASS-01: the cart's answer is part of the gift-pass state
     (layout/theme.liquid GD_FLAGS.giftPicked), so a landed write updates it
     and re-reads the state as a visitor's change - arm B then shows its toast
     and swaps the bundle's coaching line (assets/benchmark-gift-pass.js) */
  const landed = (on) => {
    if (window.GD_GIFTPASS) window.GD_GIFTPASS.cartGift = on;
    if (window.GD_FLAGS && typeof window.GD_FLAGS.syncGiftPass === 'function') window.GD_FLAGS.syncGiftPass(true);
  };

  // version B's page switch: the gift radio on, or the improve ("for me") one
  const radio = (id) => document.getElementById(id);
  const setPageSwitch = (on) => {
    if (!onBPage()) return;
    const target = radio(on ? 'gd-pz-gift' : 'gd-pz-improve');
    if (target) target.checked = true;
  };

  document.addEventListener('change', (event) => {
    const box = event.target.closest && event.target.closest('[data-gd-gift-toggle]');
    if (!box) return;
    const on = box.checked;
    paint(on);
    setPageSwitch(on);
    write(on).then(() => landed(on), () => {
      paint(!on);
      setPageSwitch(!on);
    });
  });

  let wired = false;
  const wirePage = () => {
    if (wired || !onBPage()) return;
    wired = true;
    ['gd-pz-gift', 'gd-pz-improve'].forEach((id) => {
      const input = radio(id);
      if (!input) return;
      input.addEventListener('change', () => {
        if (!input.checked) return;
        const on = id === 'gd-pz-gift';
        paint(on);
        write(on).then(() => landed(on), () => paint(!on));
      });
    });
    // back on version B with a cart that already says gift: the page's switch
    // starts on too, unless the visitor (or an ad link) has picked already
    if (boxes().some((box) => box.checked) && !document.querySelector('input.pz-radio:checked')) setPageSwitch(true);
  };
  wirePage();
  document.addEventListener('gd:pz-arm', () => {
    if (!isB()) return;
    markSeen();
    reveal();
  });
  document.addEventListener('gd:pz-ready', wirePage);

  // the drawer's footer is rebuilt when the cart empties and fills again
  reveal();
  const drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) new MutationObserver(reveal).observe(drawer, { childList: true, subtree: true });

  // idle: settles once every queued attribute write has (benchmark-gift-pass.js waits on it)
  window.GDGiftToggle = { write, reveal, idle: () => queue };
})();
